import { Component, EventEmitter, Output } from '@angular/core';

import { ProjectType } from '@mirage-projects/cw-models';

import { AddDataOption, AddDataOptionTypeData } from '../project-layer-option';

/**
 * Component to select the type of project or layer to create
 */
@Component({
    selector: 'cw-select-data-type',
    templateUrl: './select-data-type.component.html',
    standalone: false,
})
export class SelectDataTypeComponent {
    /** Event to emit the selected data type */
    @Output() selectedTypeChanged: EventEmitter<AddDataOptionTypeData> = new EventEmitter();

    readonly dataOptions: AddDataOption[] = [
        {
            keyText: 'NAVBAR.NEW_SCAN_PROJECT',
            typeData: { type: 'new_project', projectType: ProjectType.SCAN },
        },
        {
            keyText: 'NAVBAR.NEW_PROJECT_FROM_ZIP',
            typeData: { type: 'create_wizard' },
        },
        {
            keyText: 'NAVBAR.NEW_LAYER',
            typeData: { type: 'new_layer' },
        },
        {
            keyText: 'CREATE_PROJECT.EXISTING_PROJECT',
            typeData: { type: 'existing_project' },
        },
    ];

    /**
     * Set the selected new project process
     * @param typeDataEvent Event with the value index of the project options array
     */
    setSelectedType(typeDataEvent: Event): void {
        if (!typeDataEvent) {
            return;
        }

        const element = typeDataEvent.target as HTMLInputElement;
        const typeData = this.dataOptions[+element.value]?.typeData;

        this.selectedTypeChanged.emit(typeData);
    }
}
